module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/signin-cover-58aa4ea664da064189725b653eab0869.jpg";